import { render, staticRenderFns } from "./action-sheet.vue?vue&type=template&id=e064ab4a&scoped=true"
import script from "./action-sheet.vue?vue&type=script&lang=js"
export * from "./action-sheet.vue?vue&type=script&lang=js"
import style0 from "./action-sheet.vue?vue&type=style&index=0&id=e064ab4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e064ab4a",
  null
  
)

export default component.exports